import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getApplicationType = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/app-type/list' });

  return data;
};

export default getApplicationType;
